import { CommandJob } from "~/components/build/Show/lib/types";
import { CommandStep } from "~/lib/pipeline";
import { JobCount, StatsJobCount } from "~/components/build/Show/components/JobCount";

interface Props {
  jobs: CommandJob[];
  step: CommandStep;
}

export function Jobs({ jobs, step }: Props) {
  const failedCount = jobs.filter(
    (job) => job.finishedAt && !job.retriedInJobUuid && job.passed === false,
  ).length;

  return (
    <span className="text-charcoal-300">
      {Features.BuildSidebar ? <StatsJobCount step={step} /> : <JobCount jobs={jobs} step={step} />}
      {failedCount > 0 && (
        <>
          {" "}
          (<span className="text-red-500">{failedCount} failed</span>)
        </>
      )}
    </span>
  );
}
